import React from 'react';
import { Link } from 'react-router-dom';

export interface PrivacyConsentValues {
  privacy1: boolean;
  privacy2: boolean;
  privacy3: boolean;
}

interface PrivacyConsentsProps {
  values: PrivacyConsentValues;
  onChange: (values: PrivacyConsentValues) => void;
  idPrefix: string;
  privacy1Error?: string;
  labelClassName?: string;
}

export const emptyPrivacyConsents = (): PrivacyConsentValues => ({
  privacy1: false,
  privacy2: false,
  privacy3: false,
});

const PrivacyConsents: React.FC<PrivacyConsentsProps> = ({
  values,
  onChange,
  idPrefix,
  privacy1Error,
  labelClassName = 'text-xs text-gray-500 leading-relaxed',
}) => (
  <div className="space-y-3">
    <div className="flex items-start gap-2">
      <input
        type="checkbox"
        id={`${idPrefix}-privacy1`}
        checked={values.privacy1}
        onChange={(e) => onChange({ ...values, privacy1: e.target.checked })}
        className="mt-1 flex-shrink-0"
      />
      <label htmlFor={`${idPrefix}-privacy1`} className={labelClassName}>
        <span className="text-red-500">*</span> Ho letto e compreso l'{' '}
        <Link to="/privacy-policy" target="_blank" className="text-primary hover:underline">
          Informativa sulla Privacy
        </Link>{' '}
        per l'esecuzione dei servizi richiesti (ricontatto telefonico per consulenza
        personalizzata sui servizi richiesti) come specificato nell'Informativa stessa e
        approvo espressamente i{' '}
        <Link to="/termini-e-condizioni" target="_blank" className="text-primary hover:underline">
          Termini e Condizioni Generali d'Uso
        </Link>.
      </label>
    </div>
    {privacy1Error && <p className="text-red-500 text-xs">{privacy1Error}</p>}

    <div className="flex items-start gap-2">
      <input
        type="checkbox"
        id={`${idPrefix}-privacy2`}
        checked={values.privacy2}
        onChange={(e) => onChange({ ...values, privacy2: e.target.checked })}
        className="mt-1 flex-shrink-0"
      />
      <label htmlFor={`${idPrefix}-privacy2`} className={labelClassName}>
        Acconsento al trattamento dei miei dati personali per permettere a GT Energie Srl
        di inviarmi newsletter/comunicazioni di marketing riguardanti prodotti e servizi
        di GT Energie Srl o di terzi.
      </label>
    </div>

    <div className="flex items-start gap-2">
      <input
        type="checkbox"
        id={`${idPrefix}-privacy3`}
        checked={values.privacy3}
        onChange={(e) => onChange({ ...values, privacy3: e.target.checked })}
        className="mt-1 flex-shrink-0"
      />
      <label htmlFor={`${idPrefix}-privacy3`} className={labelClassName}>
        Acconsento alla cessione dei miei dati personali a terzi appartenenti ai settori
        merceologici delle telecomunicazioni ed energetici per finalità di marketing come
        dettagliato nell'{' '}
        <Link to="/privacy-policy" target="_blank" className="text-primary hover:underline">
          Informativa sulla Privacy
        </Link>.
      </label>
    </div>
  </div>
);

export default PrivacyConsents;
